export const LAST_ACTIVE_FILTER = 'last-active-filter'
